import React, { useState } from 'react';

import privacyPolicyPDF from 'assets/Future_Skill_AB_Privacy_Policy.pdf';
import { FreecodeButton } from 'components/Button/RectangleButton';
import { Modal, Header, Body, Footer } from './modalElements';
import { FilterCheckbox } from 'components/Checkbox/Checkbox';

const membershipAgreement = (
  <span>
    I accept the{' '}
    <a target="_blank" href={'/membership'} rel="noopener noreferrer">
      Future Skill Membership Agreement
    </a>
  </span>
);

const privacyPolicy = (
  <span>
    I accept the{' '}
    <a href={privacyPolicyPDF} target="_blank" rel="noopener noreferrer">
      Future Skill Privacy Policy
    </a>
  </span>
);

export default React.memo(({ onSave }) => {
  const [isAgreementAgreed, setIsAgreementAgreed] = useState(false);
  const [isGDPRAgreed, setIsGDPRAgreed] = useState(false);

  return (
    <Modal isOpen isFreecodeModal>
      <Header isFreecodeModal>Future Skill Agreement</Header>
      <Body isFreecodeModal>
        <FilterCheckbox
          isSignUpPage
          onChange={() => setIsAgreementAgreed(!isAgreementAgreed)}
          checked={isAgreementAgreed}
          label={membershipAgreement}
        />
        <FilterCheckbox
          isSignUpPage
          onChange={() => setIsGDPRAgreed(!isGDPRAgreed)}
          checked={isGDPRAgreed}
          label={privacyPolicy}
        />
      </Body>
      <Footer isFreecodeModal>
        <FreecodeButton isFreecodeButton disabled={!isAgreementAgreed || !isGDPRAgreed} onClick={onSave}>
          Save
        </FreecodeButton>
      </Footer>
    </Modal>
  );
});
